var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, HoverEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class LinkAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onMouseEnter = new HoverEventListener();
        /** @event */
        this.onMouseMove = new HoverEventListener();
        /** @event */
        this.onMouseLeave = new HoverEventListener();
    }
    /**
     * Gets the link badge.
     */
    getBadge() {
        return this.state.badge;
    }
    /**
     * Sets the link badge.
     *
     * @param badge - The link badge.
     */
    setBadge(badge) {
        this.setState({ badge });
    }
    /**
     * Returns if the link is bold.
     */
    getBold() {
        return Boolean(this.state.bold);
    }
    /**
     * Sets if the link is bold.
     *
     * @param bold - If the link is bold.
     */
    setBold(bold) {
        this.setState({ bold });
    }
    /**
     * Returns if the link is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the link is enabled.
     *
     * @param enabled - If the link is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Gets the link font family.
     */
    getFontFamily() {
        return this.state.fontFamily;
    }
    /**
    * Sets the link font family.
    *
    * @param fontFamily - The link font family.
    */
    setFontFamily(fontFamily) {
        this.setState({ fontFamily });
    }
    /**
     * Gets the link icon.
     */
    getIcon() {
        return this.state.icon;
    }
    /**
    * Sets the link icon.
    *
    * @param icon - The link icon.
    */
    setIcon(icon) {
        this.setState({ icon });
    }
    /**
     * Returns if the link should prevent default event on click.
     */
    isPreventDefault() {
        return Boolean(this.state.preventDefault);
    }
    /**
    * Sets if the link should prevent default event on click.
    *
    * @param preventDefault - If the link should prevent default event on click.
    */
    setPreventDefault(preventDefault) {
        this.setState({ preventDefault });
    }
    /**
     * Returns the link route, if it has one.
     */
    getRoute() {
        return this.state.route;
    }
    /**
     * Sets the link route.
     *
     * @param route - The link route.
     */
    setRoute(route) {
        this.setState({ route });
    }
    /**
     * Gets the link size.
     */
    getSize() {
        return this.state.size;
    }
    /**
    * Sets the link size.
    *
    * @param size - The link size.
    */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Returns if the link should stop the on click event propagation.
     */
    isStopPropagation() {
        return this.state.stopPropagation ?? false;
    }
    /**
    * Sets if the link should stop the on click event propagation.
    *
    * @param stopPropagation - If the link should stop the on click event propagation.
    */
    setStopPropagation(stopPropagation) {
        this.setState({ stopPropagation });
    }
    /**
     * Gets the link value.
     */
    getValue() {
        return this.state.value;
    }
    /**
    * Sets the link value.
    *
    * @param value - The link value.
    */
    setValue(value) {
        this.setState({ value });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onMouseEnter", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onMouseMove", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LinkAPI.prototype, "onMouseLeave", void 0);
export { LinkAPI, };
//# sourceMappingURL=link-api.js.map